var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[(_vm.canBackPage)?_c('div',{on:{"click":_vm.handleClick}},[_c('Icon',{attrs:{"name":"arrow-left"}})],1):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm.headerText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }